import { render, staticRenderFns } from "./pointsTrends.vue?vue&type=template&id=ee079860&scoped=true&"
import script from "./pointsTrends.vue?vue&type=script&lang=js&"
export * from "./pointsTrends.vue?vue&type=script&lang=js&"
import style0 from "./pointsTrends.vue?vue&type=style&index=0&id=ee079860&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee079860",
  null
  
)

export default component.exports